import { Component, OnInit, Input } from '@angular/core';
import {ConstantsService} from "../../services/constants/constants.service";

@Component({
  selector: 'app-scoring-verification',
  templateUrl: './scoring-verification.component.pug',
  styleUrls: ['./scoring-verification.component.scss'],
  standalone: false
})
export class ScoringVerificationComponent implements OnInit {
  @Input() managerData: any;
  @Input() employeeData: any;
  competenciesLeft: any;
  competenciesRight: any;
  skillsLeft: any;
  skillsRight: any;
  loading = true;

  constructor() { }

  ngOnInit(): void {
    this.mergeEmployeeData()
    this.splitData();
    this.loading = false;
  }

  splitData() {
    if (this.managerData['skills'].length > 1) {
      this.skillsLeft = this.managerData['skills'].filter((v, i) => !(i % 2));
      this.skillsRight = this.managerData['skills'].filter((v, i) => i % 2);
    }
    if (this.managerData['competencies'].length > 1) {
      this.competenciesLeft = this.managerData['competencies'].filter((v, i) => !(i % 2));
      this.competenciesRight = this.managerData['competencies'].filter((v, i) => i % 2);
    }
  }

  mergeEmployeeData() {
    if (this.managerData['skills']) {
      this.managerData['skills'].forEach(skill => {
        skill['emp_score'] = null;
        if (this.employeeData.skills) {
          skill['emp_score'] = this.employeeData.skills.find(o => o.name === skill.name).score
        }
      });
    } else if (this.employeeData['skills']) {
      this.managerData['skills'] = [];
      this.employeeData['skills'].forEach(emp => {
        this.managerData['skills'].push({emp_score: emp.score, score: null, name: emp.name});
      });
    }
    if (this.managerData['competencies']) {
      this.managerData['competencies'].forEach(comp => {
        comp['emp_score'] = null;
        if (this.employeeData.competencies) {
          let competency = this.employeeData.competencies.find(o => o.competency_id === comp.competency_id);
          if(competency !== undefined) {
            comp['emp_score'] = competency.score;
            comp['name'] = ConstantsService.COMPETENCIES_MAP[competency.competency_id];
          }
        }
      });
    } else if(this.employeeData['competencies']) {
      this.managerData['competencies'] = [];
      this.employeeData['competencies'].forEach(emp => {
        this.managerData['competencies'].push({emp_score: emp.score, score: null, name: emp.name});
      });
    }
  }
}
